
export type ModalActionType = number;
export let ModalActionType: any = {};
ModalActionType.OK = 0;
ModalActionType.Cancel = 1;
ModalActionType.Close = 2;
ModalActionType.Execute = 3;
ModalActionType.Miscellaneous = 4;
ModalActionType[ModalActionType.OK] = "OK";
ModalActionType[ModalActionType.Cancel] = "Cancel";
ModalActionType[ModalActionType.Close] = "Close";
ModalActionType[ModalActionType.Execute] = "Execute";
ModalActionType[ModalActionType.Miscellaneous] = "Miscellaneous";
